import { routes } from "@/libs/constants/routes";
import { MenuItemProps } from "@blueprintjs/core";
import { User } from "@firebase/auth";
import { Navigation as INavigation } from "@solace/types";
import cx from "classnames";
import { AnchorButtonProps, ButtonProps, NavBar } from "components";
import { getAuth, signOut } from "firebase/auth";
import { useAuthUser } from "next-firebase-auth";
import dynamic from "next/dynamic";
import Image from "next/image";
import { useMemo } from "react";
import { PageToast } from "../page-toast/page-toast";

interface AppLayoutProps {
  children: React.ReactNode;
  menus?: INavigation[];
  path?: string;
  user?: User;
  className?: string;
}

const CookieConsent = dynamic<{}>(() =>
  import("@/functional/cookie-consent").then((c) => c.CookieConsent)
);

export const AppLayout = (props: AppLayoutProps) => {
  const authUser = useAuthUser();

  const userIcon = authUser.photoURL ? (
    <Image
      src={authUser.photoURL}
      alt="user image"
      width={20}
      height={20}
      className="rounded-md"
    />
  ) : (
    "person"
  );

  const userText = authUser?.displayName ?? authUser?.email;

  const menu = useMemo<{
    toggleButton: ButtonProps;
    items: Array<MenuItemProps>;
  }>(() => {
    if (authUser.firebaseUser) {
      return {
        toggleButton: {
          className:
            "bg-transparent outline-none shadow-none bg-gray-800 rounded-md",
          icon: userIcon,
          text: userText,
          small: true,
        },
        items: [
          {
            icon: userIcon,
            text: userText,
          },
          {
            href: routes.ACCOUNT.ACCOUNT,
            text: "Account",
          },
          {
            onClick: () => signOut(getAuth()),
            text: "Logout",
          },
        ],
      };
    }
  }, [authUser]);

  const ctas = useMemo<Array<AnchorButtonProps>>(() => {
    if (!authUser.firebaseUser) {
      return [
        {
          href: {
            pathname: routes.LOGIN,
          },
          children: "Log In",
          variant: "secondary",
          className: "bg-secondary-500 mr-3",
        },
        {
          href: {
            pathname: routes.SIGNUP,
          },
          children: "Sign Up",
          variant: "primary",
        },
      ];
    }
  }, [authUser]);

  return (
    <div className={cx(props.className, "min-h-screen flex flex-col")}>
      <NavBar
        logo={{
          url: "/NuLogo_tag_darkwave_lockup@4x.png",
          width: 105,
          height: 30,
        }}
        ctas={ctas}
        menu={menu}
      />
      <PageToast />
      <CookieConsent />
      {props.children}
      {/* {!accountPage && <Footer menu={footerMenu} path={props.path} />} */}
    </div>
  );
};
